module.exports = __webpack_public_path__ + "static/media/LampOff.bf64a066.svg";